<template>
    <vx-card class="overflow-hidden relative" no-shadow card-border>
        <template slot="no-body">
            <div class="w-full flex flex-nowrap h-full overflow-hidden">
                <div
                    class="flex flex-col items-center w-12 py-1 pt-3 pb-4 text-light"
                    :style="labelStyles"
                >
                    <vx-basic-icon v-if="icon" :icon="icon" size="7" color="light" class="mb-3" />
                    <label
                        class="text-lg truncate"
                        style="writing-mode: vertical-rl; transform: rotate(180deg)"
                    >
                        <slot name="label" :label="label">
                            {{ label }}
                        </slot>
                    </label>
                </div>
                <vx-scroll-area ref="scroll">
                    <vx-input
                        v-if="filterable"
                        v-model="filter"
                        remove-validation-padding
                        class="w-full searcher"
                        icon="icon-search"
                        placeholder="Search..."
                    />
                    <div v-if="!filteredOptions.any()" class="w-full justify-center flex">
                        <span class="m-4"> No Options </span>
                    </div>
                    <div v-else class="flex flex-col justify-start gap-2 p-4">
                        <div
                            v-for="opt in filteredOptions"
                            :key="getKey(opt)"
                            class="flex items-center mb-1 p-4 h-12 overflow-hidden option truncate"
                            :class="{
                                'selected': localValue == opt,
                                'no-value': noValue
                            }"
                            :ref="localValue == opt ? 'selected' : null"
                            @click="localValue = opt"
                        >
                            <slot
                                name="option"
                                :option="opt"
                                :selected="localValue == opt"
                                :text="noValue"
                            >
                                <vs-radio
                                    v-model="localValue"
                                    :vs-value="opt"
                                    :vs-name="name || label"
                                >
                                    <slot name="option" :option="opt">
                                        <span class="ml-1">
                                            {{ getText(opt) }}
                                        </span>
                                    </slot>
                                </vs-radio>
                            </slot>
                        </div>
                    </div>
                </vx-scroll-area>
            </div>
        </template>
    </vx-card>
</template>

<script>
import ValidationMixins from '@/plugins/validation/mixins.js'
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-open-select',
    mixins: [ValidationMixins],
    props: {
        value: {
            type: null
        },
        options: {
            type: [Array, Object],
            default: () => []
        },
        icon: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        idKey: {
            type: [String, Function],
            default: 'id'
        },
        textKey: {
            type: [String, Function],
            default: 'name'
        },
        name: {
            type: String,
            default: null
        },
        valueIsId: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'primary'
        },
        filterable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        localValue() {
            this.filter = null
        }
    },
    data() {
        return {
            filter: null
        }
    },
    computed: {
        localValue: {
            get() {
                if (this.valueIsId) {
                    return this.getValueById(this.value)
                }
                return this.value
            },
            set(newValue) {
                if (this.valueIsId) {
                    this.$emit('input', this.getKey(newValue))
                    return
                }
                this.$emit('input', newValue)
            }
        },
        labelStyles() {
            return {
                'background-color': this.color_x
            }
        },
        color_x() {
            return _color.getColor(this.color)
        },
        noValue() {
            return !!this.value
        },
        options_x() {
            if (Array.isArray(this.options)) {
                return this.options
            }
            return Object.values(this.options)
        },
        filter_x() {
            return this.filter && this.filter.toLowerCase()
        },
        filteredOptions() {
            if (!this.filterable || !this.filter_x) {
                return this.options_x
            }
            var starts = []
            var includes = []
            this.options_x.forEach((o) => {
                var text = this.getText(o)
                text = text && text.toLowerCase()
                if (text.startsWith(this.filter)) {
                    starts.push(o)
                    return
                }
                if (text.includes(this.filter)) {
                    includes.push(o)
                }
            })
            return [...starts, ...includes]
        },
        getKey() {
            if (typeof this.idKey === 'string') {
                return (v) => v[this.idKey]
            }
            return this.idKey
        },
        getText() {
            if (typeof this.textKey === 'string') {
                return (v) => v[this.textKey]
            }
            return this.textKey
        }
    },
    methods: {
        getValueById(id) {
            return this.options_x.first((opt) => this.getKey(opt) == id)
        },
        scrollToSelected() {
            var element = this.$refs.selected && this.$refs.selected.first()
            if (!element) {
                return
            }
            this.$refs.scroll.scrollToElement(element, -40)
        }
    },
    mounted() {
        this.$nextTick(this.scrollToSelected)
    }
}
</script>

<style lang="scss" scoped>
.searcher {
    & :deep(input) {
        // border: none;
        border-left: none !important;
        border-right: none;
        border-top: none;
        border-radius: 0 5px 0 0;
    }
}
.option {
    user-select: none;
    cursor: pointer;
    border-radius: 4px;
    transition: opacity 0.2s ease, transform 0.3s ease;
    &.no-value {
        opacity: 0.7;
    }
    &.selected {
        transform: scale(1.05);
        opacity: 1 !important;
        box-shadow: rgb(120 120 120) 2px 2px 10px 0px;
    }
}
</style>
